import { useQuery } from "@tanstack/react-query";
import API from "Api";
import SimpleBarChart from "./SimpleBarChart";
import { Flex } from "antd";
import ButtonClose from "Components/ButtonClose";

const Dashboard = () => {
  const { data = [] } = useQuery({
    queryKey: ["dashboard"],
    queryFn: API.progress.getActivity,
    select: (data) => data.map((item) => ({ label: item.day, value: +item.count })),
  });

  console.log(data);

  return (
    <div>
      <Flex justify={"flex-end"}>
        <ButtonClose />
      </Flex>

      <h3>Активность в приложении за последние 30 дней</h3>
      <SimpleBarChart data={data} width={500} height={300} barSpacing={5} />
    </div>
  );
};

export default Dashboard;
